import { ApiResponse, partnerApi } from '../../../lib/api';
import { API_ENDPOINTS } from '../../../lib/constants';
import {
  EngageLibraryJobStatusResponse,
  EngageLibraryResponse,
  EngageLibrarySyncRequest,
  EngageLibrarySyncResponse,
} from './engage-library-types';

export async function getTenantEngageLibrary(tenantId: string): Promise<EngageLibraryResponse> {
  const response = await partnerApi.request<ApiResponse<EngageLibraryResponse>>(
    API_ENDPOINTS.ENGAGE_LIBRARY.TENANT(tenantId),
  );
  return response.data;
}

export async function syncTenantEngageLibrary(
  tenantId: string,
  request: EngageLibrarySyncRequest,
): Promise<EngageLibrarySyncResponse> {
  const response = await partnerApi.request<ApiResponse<EngageLibrarySyncResponse>>(
    API_ENDPOINTS.ENGAGE_LIBRARY.TENANT(tenantId),
    {
      method: 'PATCH',
      body: JSON.stringify(request),
    },
  );
  return response.data;
}

export async function getTenantEngageLibraryJobStatus(
  tenantId: string,
  jobId: string,
): Promise<EngageLibraryJobStatusResponse> {
  const response = await partnerApi.request<ApiResponse<EngageLibraryJobStatusResponse>>(
    API_ENDPOINTS.ENGAGE_LIBRARY.JOB(tenantId, jobId),
  );
  return response.data;
}
